import "@lottiefiles/lottie-player";
import gsap from 'gsap';

$(document).ready(function () {
    function handleScreenSize() {
        if ($(window).width() < 768) {
            removeClickHandlers();
        } else {
            addClickHandlers();
        }
    }

    function addClickHandlers() {
        const titles = $('.section_unsere_prinzipien .items .wrap-item .title');
        titles.click(function (e) {
            const $this = $(this);
            const clickedElement = $this.parent();

            if ($this.hasClass('stop')) {
                return;
            }

            $this.addClass('stop');

            const items = $('.section_unsere_prinzipien .items');
            const wrapItemElements = items.find('.wrap-item');
            const player = $('.section_unsere_prinzipien .player');

            wrapItemElements.not(clickedElement).removeClass('active');
            clickedElement.parent().addClass('active');

            if (items.hasClass('zoom')) {
                animatePlayer(player, 1, '0%', '0%', function () {
                    items.removeClass('zoom')
                });

            } else {
                items.addClass('zoom');
                const position = getPositionForElement(clickedElement.parent());
                animatePlayer(player, 2.2, position.x, position.y,);
            }

            setTimeout(function () {
                $this.removeClass('stop');
            }, 1200);
        });
    }

    function removeClickHandlers() {
        $('.section_unsere_prinzipien .items .wrap-item .title').off('click');
    }

    function animatePlayer(player, scale, x, y, onComplete = '') {
        gsap.to(player, {
            scale: scale,
            x: x,
            y: y,
            duration: 1,
            ease: "power1.inOut",
            onComplete: onComplete
        });
    }

    function getPositionForElement(element) {
        const windowWidth = $(window).width();

        if(windowWidth >= 1440){
            if (element.hasClass('wrap-item-1')) {
                return {x: '55%', y: '12%'};
            } else if (element.hasClass('wrap-item-2')) {
                return {x: '-41%', y: '17%'};
            } else if (element.hasClass('wrap-item-3')) {
                return {x: '58%', y: '-24%'};
            }
        }else {
            if (element.hasClass('wrap-item-1')) {
                return {x: '40%', y: '9%'};
            } else if (element.hasClass('wrap-item-2')) {
                return {x: '-24%', y: '12%'};
            } else if (element.hasClass('wrap-item-3')) {
                return {x: '58%', y: '-9%'};
            }
        }


    }

    $(document).ready(function () {
        handleScreenSize();
    });

    $(window).resize(function () {
        handleScreenSize();
    });
});

